import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import { url } from 'configs/';
const {
  NEWTUBE_API_SERVER,
} = url;

const FETCH_ACCOUNTDATA_REQUEST = 'foundation/setting/accountmanagement/FETCH_ACCOUNTDATA_REQUEST';
const FETCH_ACCOUNTDATA_SUCCESS = 'foundation/setting/accountmanagement/FETCH_ACCOUNTDATA_SUCCESS';
const FETCH_ACCOUNTDATA_FAIL = 'foundation/setting/accountmanagement/FETCH_ACCOUNTDATA_FAIL';

const PUT_ACCOUNTRESET_REQUEST = 'foundation/setting/accountmanagement/PUT_ACCOUNTRESET_REQUEST';
const PUT_ACCOUNTRESET_SUCCESS = 'foundation/setting/accountmanagement/PUT_ACCOUNTRESET_SUCCESS';
const PUT_ACCOUNTRESET_FAIL = 'foundation/setting/accountmanagement/PUT_ACCOUNTRESET_FAIL';

const PUT_PASSWORDRESET_REQUEST = 'foundation/setting/accountmanagement/PUT_PASSWORDRESET_REQUEST';
const PUT_PASSWORDRESET_SUCCESS = 'foundation/setting/accountmanagement/PUT_PASSWORDRESET_SUCCESS';
const PUT_PASSWORDRESET_FAIL = 'foundation/setting/accountmanagement/PUT_PASSWORDRESET_FAIL';

const IMPORT_EMPLOYEES_REQUEST = 'foundation/setting/accountmanagement/IMPORT_EMPLOYEES_REQUEST';
const IMPORT_EMPLOYEES_SUCCESS = 'foundation/setting/accountmanagement/IMPORT_EMPLOYEES_SUCCESS';
const IMPORT_EMPLOYEES_FAIL = 'foundation/setting/accountmanagement/IMPORT_EMPLOYEES_FAIL';

export default function reducer(state = {
  isLoading: false,
  datas: {},
}, action) {
  switch (action.type) {
    case FETCH_ACCOUNTDATA_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
      });
    case FETCH_ACCOUNTDATA_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        datas: action.response,
      });
    default:
      return state;
  }
}

export function fetchAccountData(isVerify, department, employee, page) {
  const paramsData = {
    IsVerify: isVerify,
    DepartmentKeyword: department,
    EmployeeKeyword: employee,
    PageNumber: page,
  };
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'employees/accounts',
      method: 'GET',
      params: paramsData,
      types: [
        FETCH_ACCOUNTDATA_REQUEST,
        FETCH_ACCOUNTDATA_SUCCESS,
        FETCH_ACCOUNTDATA_FAIL,
      ],
    },
  };
}

export function putAccountReset(employeeId, Account) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'employees/' + employeeId + '/account/reset',
      method: 'PUT',
      types: [
        PUT_ACCOUNTRESET_REQUEST,
        PUT_ACCOUNTRESET_SUCCESS,
        PUT_ACCOUNTRESET_FAIL,
      ],
      params: Account,
    },
  };
}

export function putPasswordReset(employeeId) {
  return {
    [CALL_API]: {
      url: NEWTUBE_API_SERVER + 'employees/' + employeeId + '/password/reset',
      method: 'PUT',
      types: [
        PUT_PASSWORDRESET_REQUEST,
        PUT_PASSWORDRESET_SUCCESS,
        PUT_PASSWORDRESET_FAIL,
      ],
    },
  };
}

export function importEmployees(formData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}employees/account/batch/reset`,
      method: 'PUT',
      contentType: CONTENT_TYPE.FORM,
      params: formData,
      types: [
        IMPORT_EMPLOYEES_REQUEST,
        IMPORT_EMPLOYEES_SUCCESS,
        IMPORT_EMPLOYEES_FAIL,
      ],
    },
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/Setting/screens/AccountManagement/reducers/index.js
 **/